import { Tab, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";


// ---------------------------------------------------------

// Customized Material UI Tabs Component
const NavTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 30,
  height: 30,
  '& .MuiTabs-indicator': {
    height: '100%',
    borderRadius: '22px',
    backgroundColor: theme.palette.background.defaultInverse,
  },
  '& .MuiTouchRipple-root': {
    display: 'none',
  },
}));

// Customized Material UI Tab Component
const NavTab = styled(Tab)(({ theme }) => ({
  minHeight: 30,
  height: 30,
  minWidth: 130,
  width: 130,
  color: theme.palette.background.default,
  '&.Mui-selected': {
    color: theme.palette.background.default,
    zIndex: '1',
  },
  "&:hover": {
    backgroundColor: "#8b0000",
    transition: "color 0.2s ease-in-out",
    // color: theme.palette.text.primary,
    opacity: 1,
    '&.Mui-selected': {
      color: theme.palette.background.default,
      zIndex: '1',
    },
  }
}));

// Customized Material UI Tabs Component (Vertical Orientation)
const NavTabsV = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    width: '100%',
    borderRadius: '22px',
    backgroundColor: theme.palette.background.defaultInverse,
  },
  '& .MuiTouchRipple-root': {
    display: 'none',
  },
}));

// Customized Material UI Tab Component (Vertical Orientation)
const NavTabV = styled(Tab)(({ theme }) => ({
  justifyContent: 'left',
  minHeight: 40,
  height: 40, // Default = 48px
  minWidth: '100%',
  fontFamily: theme.typography.lilitaFont,
  fontSize: "18px",
  color: theme.palette.background.defaultInverse,
  backgroundColor: theme.palette.mode === "dark"
    ? "rgba(255, 255, 255, 0.1)"
    : "rgba(22, 22, 22, 0.1)",
  borderRadius: "22px",
  '&.Mui-selected': {
    color: theme.palette.background.default,
    zIndex: '1',
  },
  "&:hover": {
    backgroundColor: "#ffd43b",
    transition: "color 0.2s ease-in-out",
    borderRadius: "22px",
    opacity: 1,
    '&.Mui-selected': {
      color: theme.palette.background.default,
      zIndex: '1',
    },
  }
}));


// ---------------------------------------------------------

export { NavTab, NavTabs, NavTabV, NavTabsV };